import React from 'react';
import { AlertTriangle, Home } from 'lucide-react';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-blue-100 flex items-center justify-center p-4 overflow-hidden">
      <div className="relative w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-2xl p-8 text-center relative z-10 
          transform transition-all duration-500 hover:scale-105">
          
          {/* Animated Error Icon */}
          <div className="flex justify-center mb-6 animate-bounce">
            <div className="bg-red-100 p-5 rounded-full">
              <AlertTriangle 
                className="text-red-500 w-16 h-16" 
                strokeWidth={1.5}
              />
            </div>
          </div>

          {/* Error Numbers with Floating Effect */}
          <div className="relative">
            <h1 className="text-8xl font-extrabold text-blue-600 
              relative inline-block animate-float">
              4
              <span className="absolute -top-2 -right-2 text-6xl text-red-500 
                animate-ping-slow">0</span>
              4
            </h1>
          </div>

          {/* Error Message */}
          <div className="mt-4 mb-6">
            <p className="text-2xl font-semibold text-gray-800 mb-3">
              Page Not Found
            </p>
            <p className="text-gray-600">
              The page you're looking for doesn't exist or has been moved.
            </p>
          </div>

          {/* Action Button */}
          <button 
            onClick={() => window.location.href = '/'}
            className="mt-6 w-full py-3 bg-blue-600 text-white 
            rounded-lg hover:bg-blue-700 transition duration-300 
            flex items-center justify-center group"
          >
            <Home className="mr-2 group-hover:animate-spin" />
            Return to Homepage
          </button>

          {/* Decorative Background Elements */}
          <div className="absolute -top-10 -left-10 w-32 h-32 bg-blue-200 rounded-full opacity-20 blur-2xl"></div>
          <div className="absolute -bottom-10 -right-10 w-32 h-32 bg-red-200 rounded-full opacity-20 blur-2xl"></div>
        </div>
      </div>

      {/* Custom Inline Styles for Animations */}
      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }
        .animate-float {
          animation: float 3s ease-in-out infinite;
        }
        .animate-ping-slow {
          animation: ping 2s cubic-bezier(0, 0, 0.2, 1) infinite;
        }
      `}</style>
    </div>
  );
};

export default NotFoundPage;